import { GxButton } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/icon_button.module.scss'

const IconButton = ({
  children,
  className = '',
  size = 'small',
  theme = 'transparent',
  ...props
}): React.ReactElement => {
  return (
    <GxButton
      variant='text'
      circle
      className={classNames({
        [style.button]: true,
        [style[`size_${size}`]]: size,
        [style[`theme_${theme}`]]: theme,
        [className]: Boolean(className)
      })}
      {...props}
    >
      {children}
    </GxButton>
  )
}

export default IconButton
